"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraitsDtoAgeGroup = void 0;
exports.TraitsDtoAgeGroup = {
    Under20: "under-20",
    In20S: "in-20s",
    In30S: "in-30s",
    In40S: "in-40s",
    In50S: "in-50s",
    Above60: "above-60",
};
